import React from 'react';
import { Icons } from 'Assets';

export const BreakdownFooter = () => (
  <div className="mt-10 bg-white md:h-[96px]">
    <div className="flex-col md:flex-row md:justify-center md:mx-auto flex md:gap-10 p-4 md:py-2">
      <div className="w-full md:w-[334px] p-4 flex items-center text-sm leading-[18px]">
        <img src={Icons.Chrono} className="w-[26px] h-[32px]" alt="Chronomètre" />
        <span className="w-full ml-4">Diagnostic immédiat de 7h à 22h, 7j/7</span>
      </div>
      <div className="w-full md:w-[385px] p-4 flex items-center text-sm leading-[18px]">
        <img src={Icons.Kitchen} className="w-7 h-8" alt="Cuisine" />
        <span className="w-full md:w-[297px] ml-4">Pour tous vos produits sous ou hors garantie, achetés ou non chez Darty</span>
      </div>
      <div className="w-full md:w-[305px] p-4 flex items-center text-sm leading-[18px]">
        <img src={Icons.Location} className="w-8 h-8" alt="Lieu" />
        <p className="ml-4">
          Intervention dans toute la France
          <span className="w-full block text-[10px] leading-[13px] mt-1">
            Hors
            <a
              target="_blank"
              rel="noreferrer"
              className="underline text-navy-blue ml-1"
              href="https://www.darty.com/res3/services/contrat-de-confiance/pdf/conditions-generales-de-vente.pdf"
            >
              zones éloignées
            </a>
          </span>
        </p>
      </div>
    </div>
  </div>
);
